{
  "slug": "low-iq-scores-explained",
  "title": "Los bajos puntajes de CI explicados de manera responsable",
  "description": "Comprenda los rangos de puntuación de CI más bajos, los intervalos de confianza, el funcionamiento adaptativo y por qué una puntuación por sí sola nunca define a una persona ni establece un diagnóstico.",
  "summary": "Un resultado de CI más bajo describe el desempeño en tareas seleccionadas en relación con un grupo de normas, y requiere una interpretación cuidadosa y respetuosa junto con la incertidumbre, las necesidades de acceso, el desarrollo y el funcionamiento diario.",
  "category": "Interpretación de la puntuación de CI",
  "sections": [
    {
      "heading": "Lo que puede y no puede significar una puntuación más baja",
      "paragraphs": [
        "En un medio-100, SD-15 Escala, puntuaciones por debajo de 85 están por debajo de la media de la población y las puntuaciones cercanas a. 70 El percentil y la clasificación exactos dependen del instrumento y de las normas, pero generalmente se encuentran entre 0 y 100.",
        "El resultado no mide el valor humano, la amabilidad, la creatividad, la experiencia práctica o todas las habilidades, pero el lenguaje, la educación, el acceso sensorial o motor, la salud, la atención y las condiciones de prueba pueden afectar el rendimiento."
      ]
    },
    {
      "heading": "El diagnóstico no se hace solo a partir del CI",
      "paragraphs": [
        "La evaluación profesional de la discapacidad intelectual considera el funcionamiento intelectual junto con el funcionamiento adaptativo en los dominios conceptual, social y de la vida práctica, con inicio durante el período de desarrollo.Una sola puntuación en línea o de detección no puede establecer ese diagnóstico.",
        "Un evaluador calificado selecciona las medidas apropiadas, considera las adaptaciones y los antecedentes, examina el intervalo de confianza e integra la información de más de una fuente."
      ]
    },
    {
      "heading": "Utilice los resultados para comprender las necesidades de soporte",
      "paragraphs": [
        "La pregunta constructiva es qué tareas son más fáciles o más difíciles y qué apoyo mejora la participación: instrucciones claras, tiempo adicional cuando sea apropiado, tecnología de asistencia, enseñanza y cambios ambientales pueden ser importantes.",
        "Si un resultado bajo es inesperado o puede afectar los servicios, hable con un profesional calificado en lugar de tomar pruebas en línea repetidamente o tratar un límite como perfectamente preciso."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Tiene un CI por debajo de 70 ¿Significa automáticamente discapacidad intelectual?",
      "answer": "El diagnóstico también requiere la evaluación del funcionamiento adaptativo y la historia del desarrollo, utilizando los estándares profesionales apropiados."
    },
    {
      "question": "¿Pueden las condiciones de prueba disminuir una puntuación?",
      "answer": "La fatiga, la enfermedad, la ansiedad, la falta de concordancia del idioma, la distracción, las barreras de acceso y otras condiciones pueden afectar el rendimiento."
    }
  ],
  "related": ["iq-80-meaning", "iq-score-ranges-explained", "how-is-iq-measured"],
  "sources": [
    {
      "label": "AAIDD — preguntas y respuestas sobre discapacidad intelectual",
      "url": "https://www.aaidd.org/docs/default-source/intellectualdisability/12th-ed-twenty-questions-faq.pdf"
    },
    {
      "label": "Pearson — WAIS-5 Informe de puntuación de muestra",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
